import { Component } from '@angular/core';
import { BaseModalComponent } from './base-modal.component';
import {
  InternalTimeLockSummaryPerson,
  InternalTimeLockSummaryTotals,
} from '../../../features/ng-salary/ng-salary.interfaces';

export interface InternalTimeLockSummaryDialogData {
  from: string;
  to: string;
  rows: InternalTimeLockSummaryPerson[];
  totals: InternalTimeLockSummaryTotals;
}

@Component({
  selector: 'app-internal-time-lock-summary-modal',
  standalone: false,
  template: require('./internal-time-lock-summary-modal.component.html').default,
  styles: [
    require('!!raw-loader!sass-loader!./base-modal.component.scss').default,
    require('!!raw-loader!sass-loader!./internal-time-lock-summary-modal.component.scss').default,
  ],
  animations: [BaseModalComponent.modalAnimations[0]],
})
export class InternalTimeLockSummaryModalComponent extends BaseModalComponent {
  from = '';
  to = '';
  rows: InternalTimeLockSummaryPerson[] = [];
  totals: InternalTimeLockSummaryTotals = {
    total_rows: 0,
    total_hours: 0,
    locked_rows: 0,
    locked_hours: 0,
    lockable_rows: 0,
    lockable_hours: 0,
  };

  configure(data: InternalTimeLockSummaryDialogData): void {
    this.from = data.from;
    this.to = data.to;
    this.rows = data.rows;
    this.totals = data.totals;
  }

  save(): void {
    this.confirm(true);
  }
}
